/*
 * @Author: Tina Huang
 * @Date: 2022-10-16 21:01:44
 * @LastEditors: HTT httishere0728@gmail.com
 * @LastEditTime: 2023-07-02 20:32:10
 * @Description: 工具函数
 */

const getCurrentDate = () => {
  // let current_date = new Date();
};

const isLogin = (token_code) => {
  // 需要验证口令
  let code = localStorage.getItem("token") || false;
  return code && code === token_code;
};

const isPhone = () => {
  //获取浏览器navigator对象的userAgent属性（浏览器用于HTTP请求的用户代理头的值）
  var info = navigator.userAgent;
  //通过正则表达式的test方法判断是否包含“Mobile”字符串
  var isPhone = /mobile/i.test(info);
  //如果包含“Mobile”（是手机设备）则返回true
  return isPhone;
};

//获取当前环境
function isWechat() {
  //判断当前环境（微信/其他）
      let ua = navigator.userAgent.toLowerCase();
      if (ua.indexOf("micromessenger") > -1) {
          return true;
      }
      return false;
  }
  

export default {
  getCurrentDate,
  isLogin,
  isPhone,
  isWechat
};
